import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rate-wrapper" }
const _hoisted_2 = {
  key: 2,
  class: "minutes-amount"
}
const _hoisted_3 = {
  key: 3,
  class: "minutes-amount"
}
const _hoisted_4 = { class: "rate-unit" }
const _hoisted_5 = { class: "rate-type-wrapper" }
const _hoisted_6 = {
  key: 4,
  class: "rate-type"
}
const _hoisted_7 = {
  key: 5,
  class: "rate-type"
}
const _hoisted_8 = {
  key: 4,
  class: "from_rate"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneIcon = _resolveComponent("PhoneIcon")!
  const _component_MobileIcon = _resolveComponent("MobileIcon")!
  const _component_LandlineIcon = _resolveComponent("LandlineIcon")!
  const _component_PremiumIcon = _resolveComponent("PremiumIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.ratePerMinute)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["upto", { single: !_ctx.hasMultipleRates }])
        }, "up to", 2))
      : (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: _normalizeClass(["from", { single: !_ctx.hasMultipleRates }])
        }, _toDisplayString(_ctx.$t('rateFinder.from')), 3)),
    (_ctx.ratePerMinute)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.ratePerMinute) + " " + _toDisplayString(_ctx.$t('rateFinder.rate.unit')), 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.amount.rate), 1),
          _createElementVNode("span", _hoisted_4, "/" + _toDisplayString(_ctx.amount.unit), 1)
        ])),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isFlat)
        ? (_openBlock(), _createBlock(_component_PhoneIcon, { key: 0 }))
        : (_ctx.type === 'mobile')
          ? (_openBlock(), _createBlock(_component_MobileIcon, { key: 1 }))
          : (_ctx.type === 'landline')
            ? (_openBlock(), _createBlock(_component_LandlineIcon, { key: 2 }))
            : (_openBlock(), _createBlock(_component_PremiumIcon, { key: 3 })),
      (!_ctx.isFlat && _ctx.title)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.title), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.isFlat
            ? _ctx.$t('rateFinder.rateType.flatRate')
            : _ctx.isMobile
              ? _ctx.$t('rateFinder.rateType.mobile')
              : _ctx.$t('rateFinder.rateType.landline')), 1))
    ]),
    (_ctx.ratePerMinute)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.hasMultipleRates
          ? _ctx.$t('rateFinder.fromAmount', { amount: `${_ctx.amount.rate}/${_ctx.amount.unit}` })
          : `${_ctx.amount.rate}/${_ctx.amount.unit}`), 1))
      : _createCommentVNode("", true)
  ]))
}